import useSession from 'Hooks/session.hook';
import { getWithExpiry } from './getset-with-expiry';

export const getSession = () => {
  return getWithExpiry(process.env.APP_SESSION);
}

export const getAccessToken = () => {
  const { accessToken } = useSession();
  return accessToken;
}

export const getProfileID = () => {
  const { profile } = useSession();
  return profile?._id;
}
